import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** ₹ in Indian short form: ₹1.2 Cr / ₹4.5 L / ₹12,000. Empty for 0/undefined. */
export function formatINR(n, { zero = "—" } = {}) {
  const v = Number(n) || 0;
  if (!v) return zero;
  if (Math.abs(v) >= 10000000) return `₹${(v / 10000000).toFixed(1)} Cr`;
  if (Math.abs(v) >= 100000) return `₹${(v / 100000).toFixed(1)} L`;
  return `₹${v.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

/** Today's date in IST as YYYY-MM-DD (business dates must not roll over at 05:30 IST because UTC did). */
export function todayIST() {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
}

/** Escape text for insertion into generated HTML (print views). */
export function escapeHtml(s) {
  return String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}

/** Deep-escape every string in a plain object/array so it can be interpolated into generated HTML. */
export function escapeDeep(v) {
  if (typeof v === "string") return escapeHtml(v);
  if (Array.isArray(v)) return v.map(escapeDeep);
  if (v && typeof v === "object") return Object.fromEntries(Object.entries(v).map(([k, x]) => [k, escapeDeep(x)]));
  return v;
}
